var map = {
	"./effect-1024.mp3": 13,
	"./effect-128.mp3": 14,
	"./effect-16.mp3": 15,
	"./effect-2.mp3": 16,
	"./effect-2048.mp3": 17,
	"./effect-256.mp3": 18,
	"./effect-32.mp3": 19,
	"./effect-4.mp3": 20,
	"./effect-4096.mp3": 21,
	"./effect-512.mp3": 22,
	"./effect-64.mp3": 23,
	"./effect-8.mp3": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;